const search = {
	toggleButton: null,
	searchForm: null,
	searchFormWrapper: null,
	searchInput: null,
	mobileMediaQuery: null,

	init() {
		this.toggleButton = document.querySelector('.js-search-toggle');
		this.searchForm = document.querySelector('.js-search-form');
		this.searchFormWrapper = document.querySelector('.js-search-form-wrapper');
		this.searchInput = this.searchForm?.querySelector('#search');

		if (!this.toggleButton || !this.searchForm) return;

		this.mobileMediaQuery = window.matchMedia('(max-width: 782px)');

		this.bindEvents();
		this.handleResize();
	},

	bindEvents() {
		this.toggleButton.addEventListener('click', (event) => this.handleToggle(event));
		this.toggleButton.addEventListener('keydown', (event) => this.handleKeydown(event));
		document.addEventListener('keydown', (event) => this.handleEscape(event));
		document.addEventListener('click', (event) => this.handleOutsideClick(event));
		this.mobileMediaQuery.addEventListener('change', () => this.handleResize());
		
		this.searchForm.addEventListener('keydown', (e) => {
			if (e.key === 'Tab') this.handleTabbing(e);
		});
	},

    isOpen() {
        return this.toggleButton.getAttribute('aria-expanded') === 'true';
    },

	handleToggle(event) {
		if (!this.mobileMediaQuery.matches) return;

		event.stopPropagation();

		const isOpen = this.isOpen();
		isOpen ? this.close() : this.open();
	},

	handleKeydown(event) {
		if (['Enter', ' '].includes(event.key)) {
			event.preventDefault();
			this.handleToggle(event);
		}
	},

	handleEscape(event) {
		if (event.key === 'Escape' && this.toggleButton.getAttribute('aria-expanded') === 'true') {
			this.close();
			this.toggleButton.focus();
		}
	},

	handleOutsideClick(event) {
		const isOpen = this.isOpen();

		if (isOpen && !this.searchForm.contains(event.target) && !this.toggleButton.contains(event.target)) {
			this.close();
		}
	},

	open() {
		this.toggleButton.setAttribute('aria-expanded', 'true');
		this.searchForm.setAttribute('aria-hidden', 'false');
        this.searchFormWrapper.classList.add('is-active');
		setTimeout(() => this.searchInput.focus(), 300);
	},

	close() {
		this.toggleButton.setAttribute('aria-expanded', 'false');
		this.searchForm.setAttribute('aria-hidden', 'true');
        this.searchFormWrapper.classList.remove('is-active');
	},

	handleTabbing(event) {
        if (!this.mobileMediaQuery.matches) return;

		if (this.toggleButton.getAttribute('aria-expanded') !== 'true') return;

		const focusable = this.searchForm.querySelectorAll('input:not([disabled]), button:not([disabled])');
		if (!focusable || focusable.length === 0) return;

		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault();
			first.focus();
		}
		
		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault();
			last.focus();
		}
	},

	handleResize() {
		if (!this.mobileMediaQuery.matches) {
			this.searchForm.removeAttribute('aria-hidden');
			this.toggleButton.removeAttribute('aria-expanded');
            this.searchFormWrapper.classList.add('is-active');
		} else if (this.toggleButton.getAttribute('aria-expanded') !== 'true') {
			this.searchForm.setAttribute('aria-hidden', 'true');
			this.toggleButton.setAttribute('aria-expanded', 'false');
            this.searchFormWrapper.classList.remove('is-active');
		}
	}
};

window.addEventListener('DOMContentLoaded', () => search.init());